module.exports = __webpack_public_path__ + "img/org.51eee7bb.png";